import React, { Component } from 'react'
import DAppInfo from './dApp-info.jsx'

export default class dApp extends Component {
    constructor(props) {
        super(props)

        this.state = {}

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        return (
            <div className="dApp-page">
                <div className="dApp-page__header">
                    <h2>dapp</h2>
                    <hr />
                </div>
                <div className="dApp-page__content">
                    <DAppInfo/>
                </div>
            </div>
        )
    }
}
